import { Injectable } from '@angular/core';

import { ApiService } from '../../services/api.service';
import { SessionService } from '../../services/session.service';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';


// import { Headers } from '@angular/http';

@Injectable()
export class ProfileService {
  constructor(private api: ApiService,private sessionService: SessionService,private http: HttpClient) {
    
  }

  saveEdits(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'edit_vendor_profile',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }
  getPaymentInfo(data){
  const obj = {
    'url': 'payment/getAdditionalPaymentStatus',
    'body': data,
    // 'headers': headers
  };
  return this.api.post(obj);
}
  changePassword(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'marketplace_change_vendor_password',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }

  accessTokenLogin(data) {
    // const headers = new Headers();
    data['app_type'] = this.sessionService.get("device_type_app")? (this.sessionService.get("device_type_app")==1?"ANDROID_HYBRID":"IOS_HYBRID") : "WEB";

    const obj = {
      'url': 'marketplace_vendor_login_via_access_token',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }

  fetchWAData(data) {
    return this.http.post<any>(
      `${environment.hippo_Notp}business/getAndUpdateOtpStatus`,
      data
    );
  }

  WAlogin(data) {
    data['app_type'] = this.sessionService.get("device_type_app")? (this.sessionService.get("device_type_app")==1?"ANDROID_HYBRID":"IOS_HYBRID") : "WEB";

    const obj = {
      'url': 'v1/whatsapp/vendor/login',
      'body': data
    };
    return this.api.post(obj);
  }

  WARegister(data){
    data['app_type'] = this.sessionService.get("device_type_app")? (this.sessionService.get("device_type_app")==1?"ANDROID_HYBRID":"IOS_HYBRID") : "WEB";

    const obj = {
      'url': 'v1/whatsapp/vendor/register',
      'body': data
    };
    return this.api.post(obj);
  }

  uploadImage(data) {
    const obj = {
      'url': 'upload_images',
      'body': data,
    };
    return this.api.post(obj);
  }

  editSignupTemplate(data) {
    const obj = {
      'url': 'edit_vendor_profile',
      'body': data,
    };
    return this.api.post(obj);
  }
  getSochitelId(data) {
    const obj = {
      'url' : 'sochitel/get_vendor_config',
      'body' : data,
    }
    return this.api.post(obj);
  }
  updateSochitel(data) {
    const obj = {
      'url' : 'sochitel/update_vendor_config',
      'body': data
    }
    return this.api.post(obj);
  }

  addSochitelId(data) {
    const obj = {
      'url' : 'sochitel/add_vendor_config',
      'body': data
    }
    return this.api.post(obj);
  }
  deleteAccount(data){
    const obj = {
      'url' : 'customer/delete',
      'body': data
    }
    return this.api.post(obj);
  }
  getBasicProfileUpdateData(customerInfo: any) {
    if (customerInfo == null) {
      customerInfo = this.sessionService.get('appData').vendor_details;
    }

    let selectedLanguage = this.sessionService.getString('language') || 'en';
    let appConfig = this.sessionService.get('config');
    let form_data = new FormData();
    form_data.append('domain_name', this.sessionService.getString('domain'));
    form_data.append('marketplace_reference_id', appConfig.marketplace_reference_id);
    form_data.append('marketplace_user_id', customerInfo.marketplace_user_id);
    form_data.append('access_token', customerInfo.app_access_token);
    form_data.append('vendor_id', customerInfo.vendor_id);
    form_data.append('language', selectedLanguage);
    
    if (customerInfo.email) {
      form_data.append('email', customerInfo.email);
    }

    if (this.sessionService.get('config') && this.sessionService.get('config').is_dual_user_enable === 1) {
     form_data.append('dual_user_key','1');
    } else {
     form_data.append('dual_user_key','0');
    }

    return form_data;
  }
}



